const pageNameKey = "questionMarkWithPopoverForGateways";

export const questionMarkWithPopoverForGatewaysEn = {
  [pageNameKey]: {
    popoverMainText: "Gateway Status",
    disconnected: "Disconnected",
    connected: "Connected",
    disconnectedText: "Connection to Gateway could not be established.",
    connectedText: "Connection to Gateway established",
  },
};

export const questionMarkWithPopoverForGatewaysPtBr = {
  [pageNameKey]: {
    popoverMainText: "Status do gateway",
    disconnected: "Desconectado",
    connected: "Conectado",
    disconnectedText: "Não foi possível estabelecer conexão com o Gateway.",
    connectedText: "Conexão com o Gateway estabelecida",
  },
};

export const questionMarkWithPopoverForGatewaysDe = {
  [pageNameKey]: {
    popoverMainText: "Gateway-Status",
    disconnected: "Getrennt",
    connected: "Verbunden",
    disconnectedText: "Verbindung zum Gateway konnte nicht hergestellt werden.",
    connectedText: "Verbindung zum Gateway hergestellt",
  },
};

export const questionMarkWithPopoverForGatewaysZhHans = {
  [pageNameKey]: {
    popoverMainText: "网关状态",
    disconnected: "已断开连接",
    connected: "已连接",
    disconnectedText: "无法建立与网关的连接。",
    connectedText: "已建立与网关的连接",
  },
};

export const questionMarkWithPopoverForGatewaysIt = {
  [pageNameKey]: {
    popoverMainText: "Stato del gateway",
    disconnected: "Disconnesso",
    connected: "Connesso",
    disconnectedText: "Impossibile stabilire la connessione con il gateway.",
    connectedText: "Connessione al gateway stabilita",
  },
};

export const questionMarkWithPopoverForGatewaysEs = {
  [pageNameKey]: {
    popoverMainText: "Estado del gateway",
    disconnected: "Desconectado",
    connected: "Conectado",
    disconnectedText: "No pudimos establecer la conexión con el gateway.",
    connectedText: "Conexión con el gateway establecida",
  },
};

export const questionMarkWithPopoverForGatewaysNl = {
  [pageNameKey]: {
    connected: "Verbonden",
    connectedText: "Verbinding met gateway tot stand gebracht",
    disconnected: "Verbinding verbroken",
    disconnectedText:
      "Er kon geen verbinding met de gateway tot stand worden gebracht.",
    popoverMainText: "Gatewaystatus",
  },
};

export const questionMarkWithPopoverForGatewaysTr = {
  [pageNameKey]: {
    connected: "Bağlı",
    connectedText: "Ağ Geçidine bağlantı kuruldu",
    disconnected: "Bağlantı kesildi",
    disconnectedText: "Ağ Geçidine bağlantı kurulamadı.",
    popoverMainText: "Ağ Geçidi Durumu",
  },
};
